import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchYearsWithHistoricalVehiclesSales = () => apiActionCreator({
  'endpoint': '/vehicles/historicalSales/years',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_YEARS_WITH_HISTORICAL_VEHICLES_SALES,
    ActionTypes.FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES,
    [
      ActionTypes.FETCHED_YEARS_WITH_HISTORICAL_VEHICLES_SALES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchHistoricalVehiclesSales = (queryString) => {
  const infoType = queryString.infoType ? `?info_type=${queryString.infoType}` : '?info_type=dealers';
  const startDate = queryString.startDate ? `&startDate=${queryString.startDate}` : '';
  const endDate = queryString.endDate ? `&endDate=${queryString.endDate}` : '';
  const dealerRuc = queryString.dealer ? `&dealer_ruc=${queryString.dealer}` : '';
  const model = queryString.model ? `&model=${queryString.model}` : '';

  return apiActionCreator({
    'endpoint': `/vehicles/historicalSales${infoType}${startDate}${endDate}${dealerRuc}${model}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_HISTORICAL_VEHICLES_SALES,
      {
        'type': ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES,
        'payload': queryString.infoType,
      },
      [
        {
          'type': ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_FAILED,
          'payload': queryString.infoType,
        },
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearHistoricalVehiclesSales = () => ({
  'type': ActionTypes.CLEAR_HISTORICAL_VEHICLES_SALES,
});
